// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import React from 'react';
import {
  withStyles,
  Breadcrumbs,
  Link,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';
import { arrayOf, shape, string, object } from 'prop-types';

import styles from './styles';

const Breadcrumb = (props) => {
    const { id, breadcrubItems, classes, containerClass = '' } = props;

    return(
      <Breadcrumbs
        aria-label="breadcrumb"
        id={id}
        data-apim-test={id}
        className={clsx(classes.container, containerClass)}
        separator={'►'}
      >
        {breadcrubItems.map((obj) =>(
          obj.isActive ?
            <Link key={obj.linkName} className={classes.linkContainer}
              color="inherit" href={obj.link}>{obj.linkName}</Link>
          :
          <Typography variant="h6" className={classes.nameContainer} key={obj.linkName} >
            {obj.linkName}
          </Typography>
        ))}
      </Breadcrumbs>
    )
}

Breadcrumb.propTypes = {
  id: string,
  breadcrubItems: arrayOf(object),
  classes: shape({}),
  containerClass: string,
};

export default withStyles(styles)(Breadcrumb);
